import classNames from "classnames"
import React, { useState } from "react"
import { FiMicOff, FiVideo, FiX } from "react-icons/fi"
import { useModal } from "../../stores/useModal"


export const PhoneCall = ({ values }) => {
    const [phone, setPhone] = useState(false)
    const toggle = useModal(state=>state.toggle)
    return (
        <div className="flex justify-center">
            <div
                className={classNames(
                    'overflow-auto backdrop-blur-sm bg-black/30',
                    {'fixed inset-0 z-50 flex items-center justify-center': phone }
                )}
            > 
                <div
                class="bg-[url(../../../public/images/profile/1.png)] bg-center bg-cover bg-white w-[350px] h-[550px] rounded-lg"
                x-show="phone"
                >
                <div
                    onClick={()=>toggle()}
                    class="absolute right-4 top-4 cursor-pointer z-50 flex sm:hidden 
                    bg-gray-500 hover:bg-gray-600 p-2 rounded-full text-white 
                    cursor-pointer items-center justify-center"
                >
                    <FiX size={23} />
                </div>

                <div class="flex justify-between flex-col p-5 h-full">
                    <div></div>
                    <div class="footer">
                    <div class="flex flex-col items-center my-6 text-white">
                        <div>
                        <img
                            src="/images/avatars/Vector-13.png"
                            class="h-20 w-20 rounded-full border mb-3 border-5 border-white"
                        />
                        </div>
                        <div class="text-sm">Video call from</div>
                        <div class="text-2xl font-bold">John Doe</div>
                    </div>
                    <div class="w-full flex items-center justify-center">
                        <div class="flex gap-4 text-white">
                        <div
                            class="p-3 rounded-full bg-red-500 hover:bg-red-600 cursor-pointer"
                        >
                            <FiX size={23} class="" />
                        </div>
                        <div
                            class="p-3 rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer text-gray-500"
                        >
                            <FiMicOff size={23} class="" />
                        </div>
                        <div
                            class="p-3 rounded-full bg-green-500 hover:bg-green-600 cursor-pointer"
                        >
                            <FiVideo size={23} class="fill-white" />
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}


